module.exports = __webpack_public_path__ + "static/pass2u-a00d9e215b0fc205cfb3f73dac718827.png";